import { ChakraBox, Popover } from '@equip.health/ui';
import { ReactNode, useState } from 'react';
import { PatientEvents } from '~/analytics/patientEvents';
import { PatientStatusHeaderPopoverBody } from '~/components/maud/patients/profile/patient-header/PatientStatusHeaderPopoverBody';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';
import { useGlobalContext } from '~/lib/contexts/GlobalContext';

interface Props {
  inquiryDetail?: InquiryDetailResponse;
  insuranceAuthorizationEndDate?: string;
  lastContactDateISO?: string;
  patientId: string;
  patientStatus: string;
  primaryDiagnosis: string;
  pausedDetails?: EpisodePausedDetails[];
  treatmentEpisode?: TreatmentEpisode;
  triggerContent: ReactNode;
  tentativeDischargeDate?: string;
}
export const PatientStatusHeaderPopover = ({
  inquiryDetail,
  insuranceAuthorizationEndDate,
  lastContactDateISO,
  patientId,
  patientStatus,
  pausedDetails,
  primaryDiagnosis,
  treatmentEpisode,
  triggerContent,
  tentativeDischargeDate,
}: Props) => {
  const { trackEvent } = useAnalytics();
  const {
    currentUser: { userId: currentUserId },
  } = useGlobalContext();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Popover
      bodyContent={
        <PatientStatusHeaderPopoverBody
          inquiryDetail={inquiryDetail}
          insuranceAuthorizationEndDate={insuranceAuthorizationEndDate}
          lastContactDateISO={lastContactDateISO}
          patientStatus={patientStatus}
          pausedDetails={pausedDetails}
          primaryDiagnosis={primaryDiagnosis}
          tentativeDischargeDate={tentativeDischargeDate}
          treatmentEpisode={treatmentEpisode}
        />
      }
      id={`patient-status-header-popover-${patientId}`}
      isOpen={isOpen}
      minWidth="450px"
      onClose={() => setIsOpen(false)}
      onOpen={() => {
        setIsOpen(true);
        trackEvent(PatientEvents.patientStatusHeaderHovered, {
          userExternalId: currentUserId,
          patientExternalId: patientId,
          patientStatus,
        });
      }}
      size="md"
      trigger="hover"
      triggerContent={<ChakraBox>{triggerContent}</ChakraBox>}
    />
  );
};
